import { createFileRoute } from "@tanstack/react-router";
import { ApiSettings } from "@/features/settings/developers";

export const Route = createFileRoute("/_app/settings/api")({
  head: () => ({ meta: [{ title: "API & integrations · Settings · Malfak" }] }),
  component: ApiSettings,
});
